import { withFormik } from 'formik';
import { connect } from 'react-redux';
import { addComment } from '../../../slices/postSlice';
import { setAlert } from '../../../slices/alertSlice';
import CommentForm from './CommentForm';
import * as Yup from 'yup';

//constants
// import {
//   EMAIL_INVALID_ERROR,
//   EMAIL_NOT_LONG_ERROR,
//   EMAIL_REQUIRED,
//   PASSWORD_REQUIRED,
//   PASSWORD_SHORT_ERROR,
// } from '../../../constants/messages/formMessages';

const EnhancedCommentForm = withFormik({
  mapPropsToValues: () => ({
    text: '',
  }),
  validationSchema: Yup.object().shape({
    text: Yup.string()
      .min(1, 'Comment should be more that one character')
      .notRequired(),
  }),
  handleSubmit: (values, { setSubmitting, resetForm, props }) => {
    const {
      addComment,
      post: { post },
    } = props;
    if (values.text === '') {
      setAlert('Please fill the form properly', 'danger');
    } else {
      addComment(values, post.post._id);
    }

    setSubmitting(false);
    resetForm({ text: '' });
  },
  displayName: 'CommentForm',
})(CommentForm);

const mapStateToProps = (state) => ({
  post: state.post,
});

export default connect(mapStateToProps, { addComment })(EnhancedCommentForm);
